import { Topbar } from "components/ui/shared/Topbar"
import { Button } from "components/ui/controls/Button";
import styled from "styled-components";
import { IndicatorCard } from "components/ui/display/IndicatorCard";
import { useContext } from "react";
import { TasksContext } from "providers/TasksProvider";
import { ProjectsContext } from "providers/ProjectsProvider";
import { ProjectsActivityContainer } from "components/features/dashboard/ProjectsActivtyContainer";
import { ProjectsMapContainer } from "components/features/dashboard/ProjectsMapContainer";
import { ImportansTasksContainer } from "components/features/dashboard/ImportanTasksContainer";
import { NotesContext } from "providers/NotesProvider";
import { RecentNotesContainer } from "components/features/dashboard/RecentNotesContainer";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";


export const Dashboard = () => {

    const { tasks } = useContext(TasksContext);
    const { projects } = useContext(ProjectsContext);
    const { notes, notebooks } = useContext(NotesContext);

    let { activeProjects, activeTasks, criticalTasks, deadlineTasks } = calculateDashboardIndicators({tasks, projects})
    
    return (     
        <>
            <Topbar breacrumb={['Dashboard']}>
                <Button
                    type='secondary'
                    text="Generer rapport"
                    prefix={<MaterialIcon name='bar_chart' weight={300}/>}
                    onClick={() =>{}}
                />
            </Topbar>
            <StyledDashboardContainer>
                <div className="dashboardHeader">
                    Dashboard
                </div>
                <div className="dashboardContent">
                    <div className="indicatorsContainer">
                        <StyledIndicatorCard
                            value={activeProjects}
                            title='Aktive prosjekter'
                            icon={<MaterialIcon name='folder_open' weight={300}/>}
                        />
                        <StyledIndicatorCard
                            value={activeTasks}
                            title='Aktive oppgaver'
                            icon={<MaterialIcon name='ballot' weight={300}/>}
                        />
                        <StyledIndicatorCard
                            value={criticalTasks}
                            unit='%'
                            title='Kritiske oppgaver'
                            icon={<MaterialIcon name='warning' weight={300}/>}
                            type='error'
                        />
                        <StyledIndicatorCard
                            value={deadlineTasks}
                            unit='%'
                            title='Fristtetthet'
                            icon={<MaterialIcon name='calendar_today' weight={300}/>}
                            type='warning'
                        />
                    </div>
                    <div className="projectInfoContainer">
                        <ProjectsActivityContainer
                            projects={projects}
                        />
                        <ProjectsMapContainer
                            projects={projects}
                        />
                    </div>
                    <div className="tasksAndNotesContainer">
                        <ImportansTasksContainer tasks={tasks} projects={projects}/>
                        <RecentNotesContainer notes={notes} projects={projects} notebooks={notebooks}/>
                    </div>
                </div>
            </StyledDashboardContainer>
        </>
    )
}


const StyledDashboardContainer = styled.div`
    padding-left: ${({theme}) => theme.spacing.xl};
    padding-right: ${({theme}) => theme.spacing.xl};
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    

    div.dashboardHeader
    {
        margin-bottom: ${({theme}) => theme.spacing.lg};
        font-size: ${({theme}) => theme.fontSize.xxl};
        font-weight: 500;
        
    }

    div.dashboardContent
    {
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.lg};
        height: 100%;
        overflow: auto;

        div.indicatorsContainer
        {
            display: flex;
            gap: ${({theme}) => theme.spacing.lg};
            flex-wrap: wrap;
        }

        div.projectInfoContainer
        {
            display: flex;
            flex-wrap: wrap;
            flex: 1 0 auto;
            gap: ${({theme}) => theme.spacing.lg};
        }

        div.tasksAndNotesContainer
        {
            display: flex;
            flex-wrap: wrap;
            flex: 1 0 auto;
            gap: ${({theme}) => theme.spacing.lg};
        }
    }
`

const StyledIndicatorCard = styled(IndicatorCard)`
    @media (min-width: ${({theme}) => theme.breakPoints.xl})
    {
        width: calc((100% - 3 * ${({theme}) => theme.spacing.lg}) / 4);
    }

    @media (max-width: ${({theme}) => theme.breakPoints.xl})
    {
        width: calc((100% - 1 * ${({theme}) => theme.spacing.lg}) / 2);
    }

    @media (max-width: ${({theme}) => theme.breakPoints.lg})
    {
        width: calc((100% - 1 * ${({theme}) => theme.spacing.lg}) / 2);
    }

    @media (max-width: ${({theme})=> theme.breakPoints.md})
    {
        min-width: 100%;
    }
`

const calculateDashboardIndicators = ({projects, tasks}) => {

    //const today = new Date();
    const currentInterval = new Date();
    currentInterval.setDate(currentInterval.getDate() + 14);

    let activeProjects = projects.filter(prj => prj.projectStatus === "Active").length;

    let activeTasks = 0;
    let criticalTasks = 0;
    let deadlineTasks = 0;

    projects.forEach(prj => {
        if(prj.projectTasks?.enabled)
        {
            let active = tasks.filter(tsk => tsk.taskProjectUuid === prj.projectUuid && tsk.taskStatus !== "Finished");
            activeTasks += active.length;

            active.forEach(tsk => {
                if(tsk.taskDeadline < currentInterval)
                {
                    deadlineTasks++
                    if(tsk.taskPriority === 3) criticalTasks++
                }
            })
        }
    });

    return {
        activeProjects,
        activeTasks,
        criticalTasks: criticalTasks/activeTasks ? Math.round(100 * criticalTasks/activeTasks) : 0,
        deadlineTasks: criticalTasks/activeTasks ? Math.round(100 * deadlineTasks/activeTasks) : 0
    }
}